<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Previous company tax relief"
      text="Create previous company tax relief"
      class="mb-0"
    >
      <form v-if="!loading">
        <v-container>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="taxRelief"
                v-validate="'required'"
                label="Tax Relief"
                :items="taxReliefs"
                :item-text="item => '['+item.code+'] - '+ item.name"
                item-value="id"
                :error-messages="errors.collect('taxRelief')"    
                data-vv-name="taxRelief" 
                data-vv-as="tax relief"
                outlined
              >
                <template v-slot:item="data">
                  <v-list-item-content style="width:270px">
                    <div class="font-weight-bold">
                      [{{ data.item.code }}] - {{ data.item.name }}
                    </div>
                    <div
                      class="font-weight-bold"
                      v-html="data.item.description"
                    />
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="amount"
                v-money="money"
                label="Amount"
                prefix="RM"
                outlined
              />
            </v-col>
          </v-row>
        </v-container> 
      </form> 

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="px-10"
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"     
          @click="submitForm"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      companyEmployeeUid: {
        type: String,
        required: true,
      },
      existingTaxRelief: {
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        progressing: false,
        dialog: false,
        amount: null,
        taxRelief: null,
        taxReliefs: [],
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
        yearFilter: parseInt(this.$moment().format('YYYY')),
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData() 

        this.loading = true

        this.$api.taxReliefs().list({ is_compulsory_deduction: 0, year: this.yearFilter })
          .then(response => {
            this.taxReliefs = _.orderBy(response.data.filter(data => {
              return !this.existingTaxRelief.includes(data.id)
            }), ['code'], ['asc'])

            this.loading = false
          })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
          
            this.progressing = true

            this.$api.companyEmployeePreviousTaxReliefs().create(this.prepareFormData())
              .then(res => {
                this.$emit('created')
                this.$snack({ message: res.data.status })
                
                this.progressing = false
                this.dialog = false
              })
              .catch(error => {
                this.progressing = false
                if (error.response.status === 405) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.message, 
                  })
                }
              })
          })
      },
      prepareFormData () {
        return {
          company_employee_uid: this.companyEmployeeUid,
          tax_relief_id: this.taxRelief,
          amount: this.amount.toString().replaceAll(',', ''),
        }
      },
    },
  }
</script>
